import { ResizeObserver as Polyfill } from '@juggle/resize-observer';

if (typeof window !== 'undefined') {
  window.ResizeObserver = Polyfill;
}

const resizeObserverErr = /ResizeObserver loop/;
window.addEventListener('error', (e) => {
  if (!resizeObserverErr.test(e.message || '')) return;
  e.stopImmediatePropagation();
  const overlay = document.getElementById('webpack-dev-server-client-overlay');
  if (overlay) overlay.remove();
}, true);

const originalError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    args[0].includes('ResizeObserver loop')
  ) {
    return;
  }
  originalError(...args);
};
